import { render } from "./PaymentDisclaimer.vue?vue&type=template&id=8f467eac"
import script from "./PaymentDisclaimer.vue?vue&type=script&lang=js"
export * from "./PaymentDisclaimer.vue?vue&type=script&lang=js"

import "./PaymentDisclaimer.vue?vue&type=style&index=0&id=8f467eac&lang=scss"

import exportComponent from "/opt/build/repo/access-trucks/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__